export default __webpack_public_path__ + "static/media/screen1.35b7f510.jpg";